// extracted by css-extract-rspack-plugin
export default {"tinkoff":"tinkoff--zlOQKmK1DLMGcXXJ"};